import { notifyError, notifySuccess } from "@lib/helper"
import http from "../httpService"
import { L, LNotification } from "@lib/abpUtility"

class PaymentRequestService {
  public async getList(params): Promise<any> {
    const res = await http.get("api/services/app/PaymentRequest/GetList", {
      params,
    })
    const { result } = res.data
    return result
  }
  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/PaymentRequest/Get", {
      params: { id },
    })
    const { result } = res.data
    return result
  }
  public async createOrUpdate(body: any) {
    const res = await http.post(
      "api/services/app/PaymentRequest/CreateOrUpdate",
      body
    )
    return res.data.result
  }
  public async activate(id: number, isActive) {
    const res = await http.post(
      "api/services/app/PaymentRequest/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  //
}

export default new PaymentRequestService()
